import * as React from "react";
import {cn} from "@/lib/utils.ts";

export default function SectionTitle(props: React.ComponentProps<"h2">) {
  return (
    <h2 {...props} className={cn("text-lg font-bold", props.className)}>
        {props.children}
    </h2>
  );
}